module.exports = __webpack_public_path__ + "img/ylImg.6b47cbde.png";